export default __webpack_public_path__ + "static/media/flag-venezuela-(bolivarian-republic-of).5581cfb4.svg";